import React, { useState } from 'react';
import AlertDialog from './AlertDialog';
import DebtDialog from './DebtDialog';
import BorrowDialog from './BorrowDialog';
import { calculateAppreciatedValue, formatCurrency, isAppreciatingAsset, CONFIG } from '../gameData';

function ActionsSection({ player, setPlayer, advanceDay, gameEnded }) {
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [showDebtDialog, setShowDebtDialog] = useState(false);
  const [showBorrowDialog, setShowBorrowDialog] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const showAlert = (message) => {
    setAlertMessage(message);
    setShowAlertDialog(true);
  };

  const handleBorrow = (amount) => {
    setShowBorrowDialog(false);

    setPlayer(prev => ({
      ...prev,
      money: prev.money + amount,
      debt: prev.debt + amount
    }));
    showAlert(`Successfully borrowed ${formatCurrency(amount)}. New debt: ${formatCurrency(player.debt + amount)}`);
  };

  const maxBorrowable = Math.max(0, CONFIG.debtLimit - player.debt);

  const handleRepayDebt = (repayAmount) => {
    setShowDebtDialog(false);
    setPlayer(prev => ({
      ...prev,
      money: prev.money - repayAmount,
      debt: prev.debt - repayAmount
    }));
    showAlert(`You repaid ${formatCurrency(repayAmount)}. Remaining debt: ${formatCurrency(player.debt - repayAmount)}`);
  };

  const handleEndDay = () => {
    if (gameEnded) return;
    
    // Update appreciated assets before advancing day
    setPlayer(prev => {
      const updatedAssets = prev.assets.map(asset => {
        if (isAppreciatingAsset(asset.name)) {
          return {
            ...asset,
            // +1 since we're about to advance the day
            currentValue: calculateAppreciatedValue(asset.basePrice, asset.purchaseDay, prev.day + 1)
          };
        }
        return asset;
      });

      return { ...prev, assets: updatedAssets };
    });

    advanceDay();
  };

  return (
    <div>
      <h2>Actions</h2>
      <button 
        onClick={() => {
          if (maxBorrowable > 0) {
            setShowBorrowDialog(true);
          } else {
            showAlert("You already owe too much!");
          }
        }} 
        disabled={gameEnded}
      >
        Borrow Money
      </button>
      <button onClick={() => setShowDebtDialog(true)} disabled={gameEnded}>Repay Debt</button>
      <button onClick={handleEndDay} disabled={gameEnded}>End Day</button>

      <AlertDialog
        show={showAlertDialog}
        message={alertMessage}
        onClose={() => setShowAlertDialog(false)}
        type="info"
      />

      <DebtDialog
        show={showDebtDialog}
        onConfirm={handleRepayDebt}
        onClose={() => setShowDebtDialog(false)}
        maxAmount={Math.min(player.money, player.debt)}
        currentDebt={player.debt}
      />

      <BorrowDialog
        show={showBorrowDialog}
        onConfirm={handleBorrow}
        onClose={() => setShowBorrowDialog(false)}
        maxBorrowable={maxBorrowable}
      />
    </div>
  );
}

export default ActionsSection; 